import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";

// import io from 'socket.io-client';

// 1. Create context
const WebSocketContext = createContext();
export const lastSentAckRef = { current: null }; // we use an object to mimic useRef


// 2. Export a custom hook for easier access
export const useWebSocket = () => useContext(WebSocketContext);

// 3. Provider component
export const WebSocketProvider = ({ children }) => {
  const auth = useSelector((state) => state.auth.auth);
  const [socket, setSocket] = useState(null);
  const listenersRef = useRef([]);
  const lastSentAckRef = useRef(null);

  useEffect(() => {
    if (!auth?.user_id) return;
    let newSocket;

    try {
      newSocket = new WebSocket(
        // "ws://212.95.50.179:8080?user_id=" + auth.user_id
        "wss://protalz.com:8085/?user_id=" + auth.user_id
      );
      console.log("show urllllllll->>>", newSocket);

      // newSocket = io(
      //   "https://ss.digittrix.com", {
      //   path: "/api/socket.io/",
      // }
      // );

      console.log("Connected to WebSocket", newSocket.readyState);

      newSocket.onopen = () => {
        console.log("Connected to WebSocket", newSocket);
        console.log("Connected to WebSocket", newSocket.readyState);
      };
      newSocket.onopen = () => {
        console.group(" SOCKET CONNECTED");
        // console.log("User ID:", auth.user_id);
        // console.log("ReadyState:", newSocket.readyState);
        console.log("URL:", newSocket.url);
        console.groupEnd();
      };


      newSocket.onmessage = (event) => {
        let dat;
        try {
          dat = JSON.parse(event.data);
          console.log("show onMessage sokcet type--->", dat.socket_type);
          console.log("show full payload--->", dat);

          if (
            dat.socket_type?.startsWith("sendMessage") &&
            (
              dat.from_user_id === auth.user_id ||
              dat.to_user_id === auth.user_id
            )
          ) {
            lastSentAckRef.current = dat;
            // console.log("Stored for BOTH sides --->", lastSentAckRef.current);
          }

          listenersRef.current.forEach((cb) => cb(dat));
        } catch (err) {
          console.error("Invalid JSON:", event.data);
        }
      };

      newSocket.onerror = (err) => {
        console.error("WebSocket error:", err);
        // console.log("websocket 2----->");
      };

      newSocket.onclose = (event) => {
        // console.warn("WebSocket connection closed.");
        console.warn("WebSocket connection closed.", event.code, event.reason);
      };

      console.log("show socket created--->", newSocket.readyState);

      setSocket(newSocket);
    } catch (err) {
      // console.log("websocket 1----->");

      console.error("WebSocket failed to connect:", err);
    }

    return () => {
      if (newSocket && newSocket.readyState === WebSocket.OPEN) {
        console.log("show web socket connection closed--->");

        newSocket.close();
      }
    };
  }, [auth]);

  const sendMessage = (message) => {
    // console.log("SHOW MESSAGE FROM SENDMESSAAGE FF--->", message);

    // lastSentAckRef.current = message
    // console.log("show lastSentASk rf--->", lastSentAckRef.current);

    try {
      if (socket?.readyState === WebSocket.OPEN) {
        // console.log("show sockets her--->", message);

        socket.send(JSON.stringify(message));
      } else {
        console.warn("WebSocket is not open, cannot send message");
      }
    } catch (err) {
      console.error("Failed to send WebSocket message:", err);
    }
  };

  const addMessageListener = useCallback((callback) => {
    listenersRef.current.push(callback);
    return () => {
      listenersRef.current = listenersRef.current.filter(
        (cb) => cb !== callback
      );
    };
  }, []);

  return (
    <WebSocketContext.Provider
      value={{
        socket,
        sendMessage,
        addMessageListener,
        lastSentAckRef
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};
